import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../api';
import { useAdmin } from '../../context/AdminContext';

export default function AdminLogin() {
  const [form, setForm]         = useState({ email: '', password: '' });
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [showPass, setShowPass] = useState(false);
  const { login }               = useAdmin();
  const navigate                = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/login', form);
      login(res.data.admin, res.data.token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--bj-espresso) 0%, #1e3f6b 100%)',
      padding: 16
    }}>
      {/* Decorative circle */}
      <div style={{
        position: 'fixed', top: -80, right: -80,
        width: 320, height: 320, borderRadius: '50%',
        background: 'rgba(63,114,175,0.12)', pointerEvents: 'none'
      }} />
      <div style={{
        position: 'fixed', bottom: -60, left: -60,
        width: 240, height: 240, borderRadius: '50%',
        background: 'rgba(63,114,175,0.08)', pointerEvents: 'none'
      }} />

      <div style={{ width: '100%', maxWidth: 400, position: 'relative' }}>

        {/* Logo card */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img
            src="/logo.png"
            alt="Bluejay Travels"
            style={{ height: 68, width: 'auto', margin: '0 auto 10px' }}
          />
          <p style={{
            margin: 0, color: 'rgba(255,255,255,0.55)',
            fontSize: '0.78rem', fontWeight: 700,
            letterSpacing: '0.12em', textTransform: 'uppercase'
          }}>
            Admin Portal
          </p>
        </div>

        {/* Form card */}
        <div style={{
          background: '#fff',
          borderRadius: 16,
          padding: '32px 28px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.25)'
        }}>
          <h2 style={{ margin: '0 0 6px', fontSize: '1.3rem' }}>Welcome back</h2>
          <p style={{ margin: '0 0 24px', fontSize: '0.85rem', opacity: 0.55 }}>
            Sign in to manage the Bluejay Travels website.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-field" style={{ marginBottom: 16 }}>
              <label htmlFor="email">Email address</label>
              <input
                id="email"
                type="email"
                required
                placeholder="admin@bluejaytravels.com"
                value={form.email}
                onChange={function(e) { setForm({ ...form, email: e.target.value }); }}
              />
            </div>

            <div className="form-field" style={{ marginBottom: 8 }}>
              <label htmlFor="password">Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  id="password"
                  type={showPass ? 'text' : 'password'}
                  required
                  placeholder="••••••••"
                  value={form.password}
                  onChange={function(e) { setForm({ ...form, password: e.target.value }); }}
                  style={{ paddingRight: 44, width: '100%' }}
                />
                <button
                  type="button"
                  onClick={function() { setShowPass(!showPass); }}
                  style={{
                    position: 'absolute', right: 12, top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none', border: 'none',
                    cursor: 'pointer', padding: 4,
                    color: 'var(--bj-espresso)', opacity: 0.45,
                    fontSize: '0.82rem', fontWeight: 700,
                    fontFamily: 'var(--font-body)',
                    userSelect: 'none',
                    transition: 'opacity 0.15s'
                  }}
                  onMouseEnter={function(e) { e.currentTarget.style.opacity = 0.8; }}
                  onMouseLeave={function(e) { e.currentTarget.style.opacity = 0.45; }}
                  aria-label={showPass ? 'Hide password' : 'Show password'}
                >
                  {showPass ? 'HIDE' : 'SHOW'}
                </button>
              </div>
            </div>

            <div style={{ textAlign: 'right', marginBottom: 20 }}>
              <Link
                to="/admin/forgot-password"
                style={{ fontSize: '0.82rem', color: 'var(--bj-clay)', fontWeight: 600 }}
              >
                Forgot password?
              </Link>
            </div>

            {error && (
              <p className="form-message error" style={{ marginBottom: 16 }}>{error}</p>
            )}

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', padding: '13px' }}
              disabled={loading}
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}>
          © {new Date().getFullYear()} Bluejay Travels · Powered by Sharda Travel Pvt. Ltd.
        </p>
      </div>
    </div>
  );
}